module.exports = "<div class=\"js-dropdown-region\"></div>";